import Badge from '../ui/Badge'
import { faqContent } from '../../data/landing-content'

export default function FAQ() {
  return (
    <section id="resources" className="mt-22 grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-start">
      <div>
        <Badge variant="dark">{faqContent.eyebrow}</Badge>
        <h2 className="text-[clamp(2rem,2.8vw+1rem,2.8rem)] tracking-[-0.03em] font-bold m-0 mt-6 mb-4">
          {faqContent.title}
        </h2>
        <p className="text-ink-soft leading-relaxed m-0">
          {faqContent.description}
        </p>
      </div>

      <div>
        {faqContent.questions.map((item, idx) => (
          <details
            key={idx}
            open={idx === 0}
            className="bg-surface-muted border border-[rgba(27,33,54,0.06)] rounded-sm px-6 py-5 mb-4 group"
          >
            <summary className="font-semibold text-[1.05rem] cursor-pointer list-none select-none">
              {item.question}
            </summary>
            <p className="mt-3 text-ink-soft leading-relaxed">
              {item.answer}
            </p>
          </details>
        ))}
      </div>
    </section>
  )
}
